const Automation = {
  path: "",
  name: "",
  redirect: "/automation",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/automation",
      redirect: "/automation",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Automation",
      meta: {
        requiresAuth: true,
        activeUrl: "/automation",

        parent: "automation",
        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/automation/index"),
          meta: {
            requiresAuth: true,
            activeUrl: "/automation",
            parent: "automation",

            lv: 2,
          },
        },
        {
          path: "detail/:id",
          name: "Automation Detail",
          component: () => import("@/views/pages/automation/detail/Detail"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/automation",
            parent: "automation",

            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default Automation;
